module.exports = __webpack_public_path__ + "img/joker-min.ae0fbe56.png";